import {Dispatch} from "react";


/* Types, Constants, Utils */
import * as Constants from "../constants";
import {ISavedState, TSavedDocument} from "../types/redux/saved";

/* Redux */
import {addToSavedDocuments} from "../redux/slices/saved-slice";
import {AnyAction} from "@reduxjs/toolkit";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../redux";
import {addToast} from "../redux/slices/toast-slice";
import {setLoginModalActive} from "../redux/slices/login-modal-slice";

/* Api */
import SavedService from "../api/saved";


const useSaveSelected = (): any => {
  const dispatch:Dispatch<AnyAction> = useDispatch();
  const savedDocuments: TSavedDocument[] = useSelector<RootState, ISavedState>(state => state.saved).documents;

  return async (selectedRecords: any[]): Promise<any> => {
    /* Get saved document id with solr document id */
    const savedDocumentIdsObj: any[] = [];
    const unSaveDocumentsId: string[] = [];
    selectedRecords.forEach((record: any) => {
      const saveDocument: TSavedDocument | undefined = savedDocuments.find((savedDocument: TSavedDocument) => record.id === savedDocument.documentId)
      if (saveDocument) {
        /* backend requires object */
        savedDocumentIdsObj.push({id: String(saveDocument.id)})
      } else {
        unSaveDocumentsId.push(record.id)
      }
    });

    if (unSaveDocumentsId.length !== 0) {
      /* save documents that are not saved */
      const recordsToSave: TSavedDocument[] = unSaveDocumentsId.map((id: string) => {
        return {
          dateCreated: '',
          id: -1,
          documentId: id,
          tags: [],
          notes: null
        }
      });

      try {
      const savedDocuments: TSavedDocument[] = await SavedService.saveDocuments(recordsToSave);
        dispatch(addToSavedDocuments(savedDocuments));
        savedDocuments.forEach(saveDocument => {
          savedDocumentIdsObj.push({id: String(saveDocument.id)})
        })
      } catch (e: any) {
        const _e = JSON.parse(JSON.stringify(e)); // status is not parsed correctly in raw error
        if ((_e.status === 403) || (_e.status === 401)) {
          dispatch(setLoginModalActive(true));
        } else {
          dispatch(addToast({
            bg: 'bg-danger',
            msg: Constants.ERROR_NOTIFICATION,
            id: -1
          }))
        }
      }
    }

    return savedDocumentIdsObj;
  };
};

export default useSaveSelected;
